import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import IconButton from '../IconButton/index.esm.js';

var CloseButton = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$label = props.label,
      label = _props$label === void 0 ? 'Close' : _props$label,
      rest = _objectWithoutPropertiesLoose(props, ["label"]);

  return React__default.createElement(IconButton, _extends({
    ref: ref,
    icon: "close",
    appearance: "ghost",
    label: label
  }, rest));
});

if (__DEV__) {
  CloseButton.displayName = 'CloseButton';
}

export default CloseButton;
//# sourceMappingURL=index.esm.js.map
